import { render, staticRenderFns } from "./goodsStatisticalSummary.vue?vue&type=template&id=131c8dcc&"
import script from "./goodsStatisticalSummary.vue?vue&type=script&lang=js&"
export * from "./goodsStatisticalSummary.vue?vue&type=script&lang=js&"
import style0 from "./goodsStatisticalSummary.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports